define('modules/form/multisearchabletext_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',
  'modules/form/convert-form-data',

  'text!./multisearchabletext_template.html',
  'selectize',
], function (Backbone, $, _, FormItemView, convertFormData, template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      var lang = false;
      for (var i in options.model.attributes.options) {
        if (i) {
          var langs = options.model.attributes.options[i].value.split('<br>');
          if (langs.length == 2) {
            lang = true;
            options.model.attributes.options[i].valueFin = langs[0];
            options.model.attributes.options[i].valueSwe = langs[1];
          } else {
            options.model.attributes.options[i].valueFin = langs[0];
            options.model.attributes.options[i].valueSwe = '';
          }
        }
      }
      options.model.attributes.lang = lang;
      _.extend(this, options);

      FormItemView.prototype.initialize.apply(this, options);
      var value = {};

      value[this.model.get('name')] = this.model.get('value');

      this.dataModel.set(value);
      this.render();
    },

    events: {
      'click .multisearchabletext-swap': 'swapText',
      'focus input.main': 'triggerFocus',
      'blur input.main': 'triggerBlur',
      'keypress input.main': 'handleKeypress',
      'keydown input.main': 'handleKeypress',
      'input .input-multitext.main': 'handleChange',
      'input .input-multitext.other': 'handleSweChange',
      'mousedown .multisearchabletext-option': 'fillData',
    },

    swapText: function (e) {
      var current = this.$(
        '#multisearchabletext-' + this.model.get('name') + '-container .other'
      ).css('display');
      if (current == 'none') {
        e.target.innerText = 'Suomenkielinen';
        this.$(
          '#multisearchabletext-' + this.model.get('name') + '-container .other'
        ).css('display', 'block');
        this.$(
          '#multisearchabletext-' + this.model.get('name') + '-container .main'
        ).css('display', 'none');
      } else {
        e.target.innerText = 'Ruotsinkielinen';
        this.$(
          '#multisearchabletext-' + this.model.get('name') + '-container .other'
        ).css('display', 'none');
        this.$(
          '#multisearchabletext-' + this.model.get('name') + '-container .main'
        ).css('display', 'block');
      }
    },

    handleChange: function (e) {
      this.setValue();
      this.triggerFocus();
      var input, filter, options, i;
      input = $(e.target);
      filter = input.val().toUpperCase();
      options = this.$('#multi-' + this.model.get('name') + '-options li');
      for (i = 0; i < options.length; i++) {
        var txtValue = options[i].textContent || options[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          $(options[i]).css('display', '');
        } else {
          $(options[i]).css('display', 'none');
        }
      }

      if (filter.length <= 1) {
        this.$(
          '#multisearchabletext-' +
            this.model.get('name') +
            '-container .multisearchabletext-highlight'
        ).removeClass('multisearchabletext-highlight');
        var swe = this.$(
          '#multisearchabletext-' + this.model.get('name') + '-container .other'
        );
        swe.attr('value', '');
        swe.val('');
        this.setValue();
        return;
      }

      this.$(
        '#multisearchabletext-' +
          this.model.get('name') +
          '-container .multisearchabletext-highlight'
      ).removeClass('multisearchabletext-highlight');
      this.$('#multi-' + this.model.get('name') + '-options li:visible')
        .first()
        .addClass('multisearchabletext-highlight');
    },

    handleKeypress: function (e) {
      var highlighted, choices, i;
      switch (e.keyCode) {
        case 13:
          var highlight = this.$(
            '#multisearchabletext-' +
              this.model.get('name') +
              '-container .multisearchabletext-highlight'
          ).first();
          this.fillData({ target: highlight });
          e.stopPropagation();
          return false;
        case 38:
          highlighted = this.$(
            '#multisearchabletext-' +
              this.model.get('name') +
              '-container .multisearchabletext-highlight'
          );
          if (highlighted) {
            highlighted = highlighted[0];
          }
          choices = this.$(
            '#multisearchabletext-' +
              this.model.get('name') +
              '-container li:visible'
          );
          for (i = 0; i < choices.length; i++) {
            if (highlighted == choices[i] && i > 0) {
              $(highlighted).removeClass('multisearchabletext-highlight');
              $(choices[i - 1]).addClass('multisearchabletext-highlight');
              this.$(
                '#multisearchabletext-' +
                  this.model.get('name') +
                  '-container ol'
              ).animate(
                {
                  scrollTop: i * 42 - 42,
                },
                0
              );
            }
          }
          e.stopPropagation();
          return false;
        case 40:
          highlighted = this.$(
            '#multisearchabletext-' +
              this.model.get('name') +
              '-container .multisearchabletext-highlight'
          );
          if (highlighted.length != 0) {
            highlighted = highlighted[0];
          } else {
            this.$(
              '#multisearchabletext-' +
                this.model.get('name') +
                '-container li:visible'
            )
              .first()
              .addClass('multisearchabletext-highlight');
          }
          choices = this.$(
            '#multisearchabletext-' +
              this.model.get('name') +
              '-container li:visible'
          );
          for (i = choices.length - 1; i > -1; i--) {
            if (highlighted == choices[i] && i < choices.length - 1) {
              $(highlighted).removeClass('multisearchabletext-highlight');
              $(choices[i + 1]).addClass('multisearchabletext-highlight');
              this.$(
                '#multisearchabletext-' +
                  this.model.get('name') +
                  '-container ol'
              ).animate(
                {
                  scrollTop: i * 42,
                },
                0
              );
            }
          }
          e.stopPropagation();
          return false;
        case 27:
          this.$('#multisearchabletext-' + this.model.get('name')).blur();
          return false;
        default:
          break;
      }
    },

    handleSweChange: function (e) {
      this.setValue();
    },

    setValue: function () {
      var valueSwe, valueFin;
      valueFin = this.$(
        '#multisearchabletext-' + this.model.get('name') + '-container .main'
      ).val();
      valueSwe = this.$(
        '#multisearchabletext-' + this.model.get('name') + '-container .other'
      ).val();
      valueFin = valueFin ? valueFin : '';
      valueSwe = valueSwe ? valueSwe : '';
      if (valueFin && valueSwe) {
        this.dataModel.set(
          this.model.get('name'),
          valueFin + '<br>' + valueSwe
        );
      } else {
        this.dataModel.set(this.model.get('name'), valueFin + valueSwe);
      }
    },

    triggerFocus: function () {
      this.dataModel.trigger('has-focus');
      this.$('#multi-' + this.model.get('name') + '-options').css(
        'display',
        'block'
      );
    },

    triggerBlur: function () {
      this.dataModel.trigger('lost-focus');
      this.$('#multi-' + this.model.get('name') + '-options').css(
        'display',
        'none'
      );
    },

    fillData: function (e) {
      var fin = this.$('#multisearchabletext-' + this.model.get('name'));
      var swe = this.$(
        '#multisearchabletext-' + this.model.get('name') + '-container .other'
      );
      var target = $(e.target);

      var highlights = this.$(
        '#multisearchabletext-' +
          this.model.get('name') +
          '-container .multisearchabletext-highlight'
      );
      highlights.removeClass('multisearchabletext-highlight');
      target.addClass('multisearchabletext-highlight');

      fin.attr('value', target.attr('valueFin'));
      fin.val(target.attr('valueFin'));
      swe.attr('value', target.attr('valueSwe'));
      swe.val(target.attr('valueSwe'));

      this.setValue();
      this.triggerBlur();
    },

    template: null,

    render: function () {
      this.template = _.template(template);
      var multi = this.model.get('value').split('<br>');
      if (multi.length > 1) {
        this.model.set('valueFin', multi[0]);
        this.model.set('valueSwe', multi[1]);
      } else {
        this.model.set('valueFin', multi[0]);
        this.model.set('valueSwe', '');
      }
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },
    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

